<ng-container
  [formGroup]="form"
  *ngIf="form.get(fieldName) || fieldControl; let f;">
  <label *ngIf="fieldLabel" [for]="fieldName" class="form-label">{{ fieldLabel }}</label>
  <textarea
    *ngIf="!readonlyField; else readonlyInput"
    type="text"
    class="form-control"
    [formControl]="f"
    [class.is-invalid]="f.errors"
    [id]="fieldName"
    [attr.placeholder]="placeholder ? placeholder : null"
    [rows]="rows">
    </textarea>
  <ng-template #readonlyInput>
      <textarea
        type="text"
        disabled
        class="form-control"
        [class.is-invalid]="f.errors"
        [value]="f.value"
        [id]="fieldName"
        [rows]="rows">
      </textarea>
  </ng-template>
  <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>
  <field-warnings [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>
</ng-container>





